import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { UPCLAIM_ROLES } from "@upclaim/sdk/src/admin-roles";

import { UsersPage } from "@/features/admins/components/users-page";
import { ALL_TENANTS } from "@/features/tenants/lib/tenant-filter";
import { useCurrentUser } from "@/hooks/use-current-user";

const usersSearchSchema = z.object({
  tenant: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_authed/_dashboard/users/")({
  validateSearch: usersSearchSchema,
  component: UsersRoute,
});

/** Port of Users.vue — role gate mirrors the Vue nav permissions. */
function UsersRoute() {
  const { can } = useCurrentUser();
  const { tenant } = Route.useSearch();
  const navigate = Route.useNavigate();

  if (!can([...UPCLAIM_ROLES, "CUSTOMER_ADMIN", "CUSTOMER_ACCOUNT_MANAGER"])) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4">
        <h1 className="text-4xl font-bold">404</h1>
        <p className="text-muted-foreground">Cette page n'existe pas.</p>
      </div>
    );
  }

  return (
    <UsersPage
      tenant={tenant ?? ALL_TENANTS}
      onTenantChange={(next) =>
        void navigate({
          search: (prev) => ({ ...prev, tenant: next === ALL_TENANTS ? undefined : next }),
          replace: true,
          resetScroll: false,
        })
      }
    />
  );
}
